import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import { Link, useNavigate } from 'react-router-dom';
import './Dashboard.css';
import Logo from '../assets/loyaltap_logo.png';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useTranslation } from 'react-i18next';
import PublicListingToggle from './PublicListingToggle';
import DebugClaims from './Admin/DebugClaims';

function Dashboard() {
  const loggedInAdmin = localStorage.getItem('username') || 'Admin';
  const adminRole = localStorage.getItem('userRole') || 'Role not defined';
  const coffeeShopId = auth.currentUser?.uid;
  const coffeeShopName = localStorage.getItem('coffee_shop_name');
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      alert("Logout failed: " + error.message);
    }
  };

  const isWorker = adminRole === 'worker';
  const isManagerOrHigher = ['manager', 'owner', 'system_admin'].includes(adminRole);

  const { currencyCode, changeCurrency } = useCurrency();

  return (
    <div className="dashboard-container">
   <header className="dashboard-header">
  <div className="logo-container1">
    <img src={Logo} alt="LoyalTap Logo" className="logo-image" />
  </div>

  <h1 className="responsive-title font-color">{t('dashboard_title')}</h1>

 
  <div className="language-dropdown-wrapper">
    <select
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      value={i18n.language}
      className="language-select"
    >
      <option value="en">🇬🇧 English</option>
      <option value="sv">🇸🇪 Svenska</option>
      <option value="ro">🇷🇴 Română</option>
    </select>

    <select
      value={currencyCode}
      onChange={(e) => changeCurrency(e.target.value)}
      className="language-select"
    >
      <option value="EUR">€ Euro</option>
      <option value="SEK">kr Swedish Krona</option>
      <option value="RON">lei Romanian Leu</option>
    </select>
  </div>
</header>

      <div className="dashboard-scrollable">
        <div className="dashboard-content">
          <div className="dashboard-grid">
            {isManagerOrHigher && (
              <>
                <Link to="/edit-users" className="dashboard-button" style={{ background: '#9B59B6' }}>
                   {t('edit_admins')}
                </Link>

                <Link to="/register-admin" className="dashboard-button" style={{ background: '#FF6B6B' }}>
                  {t('register_admin')}
                </Link>
                <DebugClaims />

                <Link to="/manage-offers" className="dashboard-button" style={{ background: '#FF85A2' }}>
                  {t('manage_offers')}
                </Link>

                <div className="dashboard-button" style={{ background: '#6C63FF' }} onClick={() => navigate('/manage-employees')}>
                  {t('manage_employees')}
                </div>

                <div
                  className="dashboard-button"
                  style={{ background: '#78B378' }}
                  onClick={() => navigate('/manage-tombola', { state: { coffeeShopId } })}
                >
                  {t('manage_tombola')}
                </div>
              </>
            )}

            {(isWorker || isManagerOrHigher) && (
              <>
                <Link to="/generate-link" className="dashboard-button" style={{ background: '#1ABC9C' }}>
                  {t('generate_link')}
                </Link>

                <Link to="/view-customer-links" className="dashboard-button" style={{ background: '#F39C12' }}>
                  {t('view_customer_links')}
                </Link>
              </>
            )}

            <Link to="/AiSuggestions.jsx" className="dashboard-button" style={{ background: '#FF9F70' }}>
              {t('view_ai_suggestions')}
            </Link>
          
            <Link to="/manage-retail-offers" className="dashboard-button" style={{ background: '#FF5F30' }}>
   {t('manage_retail_offers')}
</Link>

{isManagerOrHigher && (
  <Link to="/public-landing" className="dashboard-button" style={{ background: '#00bcd4' }}>
    🌍 {t('view_top_locations')}
  </Link>
)}
     <button onClick={() => navigate('/admin/clinic-dashboard')} className="dashboard-button" style={{ background: '#1fd358' }}>
  🏥 {t('goToClinicDashboard')}
</button>
<button
  onClick={() => navigate('/manage-assets')}
  className="dashboard-button"
  style={{ background: '#0c93da' }}
>
  {t('assetsAdminManager')}
</button>
<button
  onClick={() => navigate('/register-asset')}
  className="dashboard-button"
  style={{ background: '#075cc8' }}
>
  {t('registerNewAsset')}
</button>
          </div>
          

          <div className="user-info">
            <h2>👤 {t('logged_in_as')}: <strong>{loggedInAdmin}</strong></h2>
            <p>🛡 {t('role')}: <strong>{adminRole}</strong></p>
            <p>☕️ {t('coffee_shop')}: <strong>{coffeeShopName}</strong></p>
            {(adminRole === 'owner' || adminRole === 'system_admin') && (
  <div className="listing-toggle-wrapper">
    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>
    </label>
    <PublicListingToggle coffeeShopId={localStorage.getItem('coffee_shop_id')} />
  </div>
)}
          </div>
        </div>

        <div className="footer-actions">
          <div className="dashboard-loyal about-loyaltap font-color" onClick={() => navigate('/privacy')}>
             {t('about_loyaltap')}
          </div>

          <div className="dashboard-loyal about-loyaltap font-color" onClick={handleLogout}>
            {t('logout')}
          </div>
        </div>

        <footer className="footer-branding">
      <p>
        {t('footer.powered')} <a href="https://flexpayz.com" style={{ color: '#4a90e2' }}>
          {t('footer.tech')}
        </a> © 2025. {t('footer.rights')}
      </p>
    </footer>
      </div>
    </div>
  );
}

export default Dashboard;
